/*=========================================================================================
  File Name: moduleCommonActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";
import User from "@/models/User.js";
import router from "@/router";
import IndexedDB from "@/helpers/IndexedDB.js";

export default {
	fetchDataListResource({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/resource")
				.then((res) => {
					commit("SET_RESOURCES", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	/**
	 *
	 * @param {*} param0
	 */
	getCountries({commit}) {
		const payload = {
			country: "",
			department: "",
			city: "",
			world_code: "",
			only: "country_name",
			fields: [],
		};
		return new Promise((resolve, reject) => {
			Api.post(`/divipola`, payload)
				.then((res) => {
					resolve(res);
					commit("SET_COUNTRIES", res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getDepartments({commit}, country) {
		const payload = {
			country: country.name,
			department: "",
			city: "",
			only: "department_name",
			world_code: "",
			fields: [],
		};
		return new Promise((resolve, reject) => {
			Api.post(`/divipola`, payload)
				.then((res) => {
					resolve(res);
					commit("SET_DEPARTMENTS", res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	/**
	 *
	 * @param {*} param0
	 * @param {*} resourceId
	 */
	getAllCities({commit}, country) {
		const payload = {
			country: country.name,
			department: "",
			city: "",
			world_code: "",
			fields: ["city_name", "city_id", "country_name"],
		};
		return new Promise((resolve, reject) => {
			Api.post(`/divipola`, payload)
				.then((res) => {
					resolve(res);
					commit("SET_CITIES", res.data);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	/**
	 * @description Request a divipola para obtener las ciudades por departamento
	 * @param {*} param0
	 * @param {*} departament
	 */
	getCitiesByDeparment({commit}, departament) {
		const payload = {
			country: departament.country || "",
			department: departament.name ? departament.name.replaceAll(",", "") : "",
			city: "",
			world_code: "",
			only: "city_name",
			fields: ["city_name", "department_name"],
		};
		return new Promise((resolve, reject) => {
			Api.post(`/divipola`, payload)
				.then((res) => {
					resolve(res);
					commit("SET_CITIES", res.data);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	fetchResourceById({commit}, resourceId) {
		return new Promise((resolve, reject) => {
			Api.get(`/resource/${resourceId}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	fetchDataSelect({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/role/status", payload)
				.then((res) => {
					commit("SET_DATA_SELECTS", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	fetchDataSelectVisitPoint({commit}) {
		const payload = {
			role: [1, 2, 3, 4, 5],
			status: [],
			category: "VISIT_POINT",
			typology: [],
		};
		return new Promise((resolve, reject) => {
			Api.post("/role/status", payload)
				.then((res) => {
					commit("SET_DATA_SELECTS", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	/**
	 *
	 * @param {*} param0
	 * @param {*} category "RESOURCE", "VISIT_POINT",
	 */
	fetchDataRoleStatusCategoryTypology({commit}, payload = {role: [], status: [], category: "", typology: []}) {
		return new Promise((resolve, reject) => {
			Api.post("/role/status/category/typology", payload)
				.then((res) => {
					commit("SET_ROLES_STATUS_CATEGORIES_TYPOLOGIES", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	async logout({commit}) {
		const usuario = new User();
		await usuario.getToken();
		await usuario.clearUser();
		await IndexedDB.truncate("users", null);
		router.push({name: "page-login"}).catch(() => {});
	},

	fetchStatusData({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/status")
				.then((res) => {
					commit("SET_ROLES_STATUS_CATEGORIES_TYPOLOGIES", {status: res.data});
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getDepartmentsByCityCountry({commit}, data) {
		const payload = {
			country: data.country,
			department: "",
			city: data.city,
			only: "department_name",
			world_code: "",
			fields: [],
		};
		return new Promise((resolve, reject) => {
			Api.post(`/divipola`, payload)
				.then((res) => {
					resolve(res);
					commit("SET_DEPARTMENTS", res.data);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
};
